import React, {Component} from 'react'
import FJToolbarIconButton from './FJToolbarIconButton'
import FJDropDown from "fj-components/FJDropDown"
import InlineSVG from "react-inlinesvg";
import FJWordSizeIcon from '../../../icon/FJWordSizeIcon.svg';
import FJFontSizeAddIcon from '../../../icon/FJFontSizeAddIcon.svg';
import FJFontSizeSubIcon from '../../../icon/FJFontSizeSubIcon.svg';

import './FJTextSize.less'
import FJLocalStore from "../../../store/FJLocalStore";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJUtil from "../../../util/FJUtil";

class FJTextResize extends Component {

  _toggleTooltip = (ele, bool) => {
    FJUtil.toggleTooltip(ele, bool);
  };

  render() {
    let {disabled} = this.props;
    return (
      <FJDropDown overlay={
        <div className="c-text-size-popup-panel">
          <FJToolbarIconButton tooltip={FJLocalStore._('text-bigger')} className='u-tooltip-bottom c-text-size-big'
                               onClick={this.props.zoomIn} icon={<InlineSVG src={FJFontSizeAddIcon} element='div'/>}/>
          <FJToolbarIconButton tooltip={FJLocalStore._('text-smaller')} className='u-tooltip-bottom c-text-size-small'
                               onClick={this.props.zoomOut} icon={<InlineSVG src={FJFontSizeSubIcon} element='div'/>}/>
        </div>
      }
                  canTriggerActive
                  disabled={disabled}
                  triggerClick={() => {FJCoreUtil.triggerBodyMousedown()}}
                  toggleTooltip={this._toggleTooltip}
                  hasArrow={true}

      >
        <FJToolbarIconButton disabled={disabled}
                             style={{marginRight: 0}}
                             className='u-tooltip-bottom c-toolbar-icon-btn float-left'
                             tooltip={FJLocalStore._('size')}
                             onClick={() => {
                             }}
                             icon={<InlineSVG src={FJWordSizeIcon} element='div'/>}
        />
      </FJDropDown>
    );
  }
}

export default FJTextResize;
